import React from 'react';
import Button from 'src/modules/shared/components/atoms/buttons/button';
import { Alert } from 'src/modules/shared/components/atoms/alert';
import type { IntegrationHealthAlertProps } from 'src/modules/settings/types/integration-health-alert.types';

/**
 * Standardized health error/pause alert with optional CTA.
 */
export const IntegrationHealthAlert: React.FC<IntegrationHealthAlertProps> = ({
  variant,
  message,
  cta,
  t,
}) => {
  return (
    <div className="flex flex-col gap-2">
      <Alert variant={variant} size="md" message={message} />
      {cta?.visible ? (
        <Button
          variant={variant === 'danger' ? 'danger' : 'warning'}
          appearance="soft"
          size="sm"
          onClick={cta.onClick}
          disabled={cta.disabled}
          loading={cta.loading}
          className="self-start"
        >
          {t(cta.labelKey)}
        </Button>
      ) : null}
    </div>
  );
};
